export default __webpack_public_path__ + "static/2743-1de1c2c21a1bf67fee4089db492bf1e0.jpg";